<template>
  <div class="p-8 flex">
    <header class="flex-wrap space-x-4 mb-12 w-1/2">
      <div class="flex justify-center items-center mt-12">
        <div class="bg-black h-24 w-24 rounded-full"></div>
      </div>
      <div class="flex justify-center items-center mt-12">
        <h1 class="mb-2">{{ user.first_name }} {{ user.last_name }}</h1>
      </div>
      <div>
        <p class="flex justify-center items-center mt-12">
          {{ user.bio }}
        </p>
      </div>
    </header>

    <main class="ml-12 w-1/2">
      <div class="w-96">
        <h1 class="font-bold text-white text-4xl">Edit Profile</h1>
        <el-form ref="form">
          <el-form-item label="First Name">
            <el-input
              placeholder="Please input"
              v-model="user.first_name"
            ></el-input>
          </el-form-item>

          <el-form-item label="Last Name">
            <el-input
              placeholder="Please input"
              v-model="user.last_name"
            ></el-input>
          </el-form-item>

          <el-form-item label="bio">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="Please input"
              v-model="user.bio"
            >
            </el-input>
          </el-form-item>

          <button
            @click="saveProfile()"
            class="bg-yellow-100 font-bold rounded-full p-2"
          >
            Save
          </button>
        </el-form>
      </div>
    </main>
  </div>
</template>

<script>
import { db } from "@/db";
export default {
  data: function () {
    return {
      user: {},
      user_id: "n1i6ClsxbHC3FTN1WuHC",
    };
  },
  mounted() {
    // go get the current user based on id from firbase
    db.collection("users")
      .doc(this.user_id)
      .get()
      .then((snapshot) => {
        this.user = snapshot.data();
      });
  },
  methods: {
    saveProfile() {
      console.log(this.user);
      db.collection("users")
        .doc(this.user_id)
        .set(this.user)
        .then(() => {
          console.log("updated!");

          this.showForm = false;

          // alert the message
          this.$message({
            message: "Your profile is updated",
            type: "success",
          });
        });
    },
  },
};
</script>